var ReceiverLocated;
(function (ReceiverLocated) {
    ReceiverLocated["PatientQueue"] = "patient queue";
    ReceiverLocated["OnCall"] = "on call";
    ReceiverLocated["OnCallPatientQueue"] = "on call patient queue";
    ReceiverLocated["IsProvider"] = "is provider";
    ReceiverLocated["TargetNotFound"] = "Target user was not found";
})(ReceiverLocated || (ReceiverLocated = {}));
export function determineReceiverLocatedStatus(targetPatientUUID, reduxStore) {
    const { realtime, callInfo } = reduxStore;
    const { patients } = realtime;
    const isUserOnCall = callInfo.callSession
        ? callInfo.callSession.isInCall
        : false;
    // target was the provider, not a patient
    if (!patients || !patients.length)
        return ReceiverLocated.IsProvider;
    const targetPatient = patients.find((patient) => {
        return targetPatientUUID === patient.uuid;
    });
    if (!targetPatient) {
        return ReceiverLocated.TargetNotFound;
    }
    let receiverLocatedStatus = '';
    // if the target is on an active call
    if (targetPatient.activeVideo || targetPatient.state.status === 'video') {
        receiverLocatedStatus = ReceiverLocated.OnCall;
    }
    else {
        // if no call is happening, the target must exist in a queue
        if (!isUserOnCall) {
            receiverLocatedStatus = ReceiverLocated.PatientQueue;
        }
        // if a call is happening but target is still in the queue
        if (isUserOnCall) {
            receiverLocatedStatus = ReceiverLocated.OnCallPatientQueue;
        }
    }
    return receiverLocatedStatus;
}
